//Droppable AREAS IDs
export const CONTENT_LIBRARY_DROPPABLE_ID = 'CONTENT_LIBRARY_DROPPABLE_ID';
export const ITINERARY_SERVICE_LIBRARY_DROPPABLE_ID =
  'ITINERARY_SERVICE_LIBRARY_DROPPABLE_ID';

export const TRIP_DAYS_DROPPABLE_ID = 'TRIP_DAYS_DROPPABLE_ID';
export const TRIP_DAY_CONTENT_DROPPABLE_ID = 'TRIP_DAY_CONTENT_DROPPABLE_ID';
export const TRIP_DAY_LINEITEM_DROPPABLE_ID = 'TRIP_DAY_LINEITEM_DROPPABLE_ID';
export const TRIP_CONTENT_LIST_DROPPABLE_ID = 'TRIP_CONTENT_LIST_DROPPABLE_ID';
export const TRIP_CONTENT_ITEM_DROPPABLE_ID = 'TRIP_CONTENT_ITEM_DROPPABLE_ID';
export const TRIP_AMENITIES_TABLE_DROPPABLE_ID =
  'TRIP_AMENITIES_TABLE_DROPPABLE_ID';
export const GLOBAL_AMENITIES_TABLE_DROPPABLE_ID =
  'GLOBAL_AMENITIES_TABLE_DROPPABLE_ID';

//Custom drag and drop actions
export const CREATENEWDAY = 'CREATENEWDAY';
export const CREATE_NEW_ADDITIONAL_CONTENT = 'CREATENEWADDITIONALCONTENT';
export const UPDATEDAYCONTENT = 'UPDATEDAYCONTENT';
export const UPDATE_ADDITIONAL_CONTENT = 'UPDATE_ADDITIONAL_CONTENT';
export const REORGANIZEDAYS = 'REORGANIZEDAYS';
export const REORGANIZE_ADDITIONAL_ITEMS = 'REORGANIZE_ADDITIONAL_ITEMS';
export const REORGANIZE_AMENITIES = 'REORGANIZE_AMENITIES';
export const ADD_AMENITY_FROM_LIBRARY = 'ADD_AMENITY_FROM_LIBRARY';
export const ADD_ITINERARY_SERVICE_FROM_LIBRARY =
  'ADD_ITINERARY_SERVICE_FROM_LIBRARY';

//Service types
export const SERVICE_CARD_DROPPABLE_ID = 'SERVICE_CARD_DROPPABLE_ID';
export const REORREORGANIZE_SERVICES = 'REORREORGANIZE_SERVICES';
export const ADD_SERVICE_FROM_LIBRARY = 'ADD_SERVICE_FROM_LIBRARY';
export const REORGANIZE_SERVICES = 'REORGANIZE_SERVICES';
export const ADD_SERVICE_FROM_LIBRARY_TO_DAY =
  'ADD_SERVICE_FROM_LIBRARY_TO_DAY';
export const MOVE_SERVICE_BETWEEN_DAYS = 'MOVE_SERVICE_BETWEEN_DAYS';

//LineItem types (new refactored services)
export const REORGANIZE_LINEITEMS = 'REORGANIZE_LINEITEMS';
export const MOVE_LINEITEM_BETWEEN_DAYS = 'MOVE_LINEITEM_BETWEEN_DAYS';

//Trip passenger fields
export const TRIP_PASSENGER_FIELDS_DROPPABLE_ID =
  'TRIP_PASSENGER_FIELDS_DROPPABLE_ID';
